import React from "react";
import { HistoryChangesView } from "@rankmi/ats-app";
import "./ListHistoryChanges.scss";

function ListHistoryChanges({ currentUser }) {
  return (
    <div className="listHistoryChanges">
      <HistoryChangesView currentUser={currentUser} />
    </div>
  );
}

export default ListHistoryChanges;
